<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-select-input [placeholder]="select.placeholder"
  [hasError]="select.hasError"
  [hasShadow]="select.hasShadow"
  [displayValue]="null"
  [hideInput]="!legacyMultiselect && (notEmpty$ | async)"
  [isOpen]="select.optionsOverlay.isOpen"
  [prefixIcon]="select.prefixIcon"
  [disabled]="select.disabled || select.isReadonly"
  [ariaLabel]="ariaLabel"
  [ariaLabelledby]="ariaLabelledby"
  [ariaDescribedby]="ariaDescribedby"
  [ariaValueDescription]="selectedLabels$ | async"
  (focusLost)="handleBlur()">
  @if (!legacyMultiselect) {
    <ngf-multi-select-pills [values]="values$ | async"
      (remove)="handleRemove($event)"
      (clearAll)="handleClearAll()" />
  }
</ngf-select-input>
